import React, { useState } from "react";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import { getClass, getClassCategories } from "../../Helper";
import Modal from "../../Components/Modal/Modal";
import { connect } from "react-redux";
import { updateInstRoomsPrograms } from "../../redux/college/college.actions";
import { getCanDelivers } from "./profile.utils";
import { useEffect } from "react";
import EcecCustomerFilterAccordion from "../../Components/SearchTeacherFilter/EcecCustomerCollapseFilter";


function RoomOrProgramPopup(props) {
  const { qualifications, selectedCanDelivers, selectedData, selectedByQualificationObj } = props
  const [college_can_deliver, setcan_deliver] = useState(getCanDelivers(props.institution, true));
  const [is_checked, set_is_checked] = useState("ge")
  const class_types_full = getClass(true);
  const [selectedList, setSelectedList] = useState(selectedData)
	const [levels, setVETLevel] = useState([])
  const [selectedByQualification, setSelectedByQualification] = useState(selectedByQualificationObj)


	useEffect(() => {
		// get all level of VET
    let levels = []
    let levelPriorities = []
    qualifications.filter(item => item.type === 'vet').forEach((item => {
      const subQualifications = item.qualifications
      subQualifications.forEach(ele => {
        if (!levels.includes(ele.level) && ele.level?.length) {
          levels.push(ele.level)
          levelPriorities.push({
            name: ele.level,
            priority: ele.priority
          })
        }
        else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
          const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
          levelPriorities = [
            ...levelPriorities.slice(0, itemIndex),
            {
            name: ele.level,
            priority: ele.priority
            },
            ...levelPriorities.slice(itemIndex + 1)
          ]
        }
      })
    }))

    levels.sort((a, b) => {
      const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
      const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
      return priorityA - priorityB;
    })

    setVETLevel(levels)
	}, [])

  const handleClose = () => {
    props.showPopup(false);
  };

  const setCategory = (e) => {
    set_is_checked(e.target.id)
  }

  const selectAll = (category) => {
    let newSelectedClasses = { ...college_can_deliver };
    class_types_full.filter(cl => cl.type.includes(category))
      .forEach(class_type => {
        if (newSelectedClasses[category] && !newSelectedClasses[category].includes(class_type.key)) {
          newSelectedClasses[category].push(class_type.key)
        }
      })

    setcan_deliver(newSelectedClasses);
  }


  const handleSave = () => {
    props.showPopup(false);
    props.updateInstRoomsPrograms({
        inst_id: props.institution._id,
        selected_rooms_programs: selectedList
    })
  };


  const handleLevelChange = (e, qua, rootID = null) => {
    let currentList = selectedList
    let selectedByQualificationNew = {
      ...selectedByQualification
    }
    if (e.target.checked) {
      currentList.push(e.target.value)
      if(e.target.value !== rootID) {
        currentList = currentList.filter(lv => lv !== rootID);
        if(qua?._id) {
          if(selectedByQualificationNew[qua._id]) {
            selectedByQualificationNew[qua._id] = [
              ...selectedByQualificationNew[qua._id],
              e.target.value
            ]?.filter(ele => ele !== rootID)
          }
          else {
            selectedByQualificationNew[qua._id] = [e.target.value]
          }
        }
      }
      else {
        if(qua?._id) {
          if(selectedByQualificationNew?.[qua._id]) {
            currentList = currentList.filter(lv => !selectedByQualificationNew?.[qua._id]?.includes(lv))
          }
          selectedByQualificationNew[qua._id] = [e.target.value]
        }
      }
      setSelectedList(currentList)
    } else {
      // const splitValue = e.target.value.split("_id:")?.[0]
      currentList = currentList.filter(lv => lv !== e.target.value);
      if(qua?._id && selectedByQualificationNew?.[qua._id]) {
        selectedByQualificationNew[qua._id] = selectedByQualificationNew[qua._id].filter(lv => lv !== e.target.value)
      }
      setSelectedList(currentList) 
    }
    setSelectedByQualification(selectedByQualificationNew)
  }



  return (
    <>
      <Modal
        show={true}
        onClose={handleClose}
        className="model-for-addform custom-for-addCanDeliver"
        header="Add/Remove Rooms & Programs"
      >
        {qualifications?.length && <EcecCustomerFilterAccordion 
          qualificationList={qualifications}
          levels={levels}
          selectedList={selectedList}
          onChangeCategory={(e, qua, rootID) => handleLevelChange(e, qua, rootID)}
          showTwoColumns={true}
          isChildcareCentre={true}
        />}

        <div className="row qualification-footer mt-5">
          <div className="col-md-6 buttons">
            <CancelButton onClick={handleClose}>Cancel</CancelButton>
          </div>
          <div className="col-md-6 buttons">
            <ConfirmButton onClick={handleSave}>Submit</ConfirmButton>
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateInstRoomsPrograms: (payload) => dispatch(updateInstRoomsPrograms(payload)),
});

export default connect(null, mapDispatchToProps)(RoomOrProgramPopup);
